import React from "react"
import type { LucideProps } from "lucide-react"

export const CircularAlertFillIcon: React.FC<LucideProps> = ({
  size = 24,
  color = "currentColor",
  className,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <circle key="alert-circle" cx="12" cy="12" r="10" fill="currentColor" />
      <line
        key="alert-line"
        x1="12"
        x2="12"
        y1="8"
        y2="12"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        key="alert-dot"
        x1="12"
        x2="12.01"
        y1="16"
        y2="16"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
